import { apiGet, apiPost, apiPatch } from "./client";
import type { SignalEvent, SignalEventInput } from "@sales-ops-amplify/shared";

export async function listSignals(
  limit?: number,
  q?: string,
): Promise<SignalEvent[]> {
  const res = await apiGet<{ signals: SignalEvent[] }>("/api/signals", {
    limit,
    q: q || undefined,
  });
  return res.signals ?? [];
}

export async function listSignalWatchlist(): Promise<SignalEvent[]> {
  const res = await apiGet<{ signals: SignalEvent[] }>("/api/signals/watchlist");
  return res.signals ?? [];
}

export async function createSignal(input: SignalEventInput): Promise<SignalEvent> {
  const res = await apiPost<{ signal: SignalEvent }>("/api/signals", input);
  return res.signal;
}

export async function updateSignal(
  id: string,
  patch: Partial<Pick<SignalEvent, "watchlisted" | "score" | "summary" | "title">>,
): Promise<SignalEvent> {
  const res = await apiPatch<{ signal: SignalEvent }>(`/api/signals/${id}`, patch);
  return res.signal;
}

export async function refreshMarketPulse(opts?: {
  providerIds?: string[];
}): Promise<{
  signals: SignalEvent[];
  count: number;
}> {
  return apiPost<{ signals: SignalEvent[]; count: number }>(
    "/api/signals/market-pulse",
    opts?.providerIds?.length ? { providerIds: opts.providerIds } : {},
  );
}

export async function ingestSignals(
  input: SignalEventInput | { signals: SignalEventInput[] },
): Promise<{ signals: SignalEvent[]; count: number }> {
  return apiPost("/api/signals/ingest", input);
}
